﻿<template>
    <div class="td-heading">
        <img
            v-if="product?.marketing_information?.media[0]?.assets[0]?.asset_url"
            class="td-heading-image"
            :src="product.marketing_information.media[0].assets[0].asset_url + '?anchor=center&mode=crop&width=480&height=320'"
            :alt="imageAltText() || ''"
        >
        <div class="td-heading-text">
            <h3 class="tourTitle">{{getGroupName()}}</h3>
            <p>{{getDescription()}}</p>
        </div>
    </div>
    <div v-if="!isAgent_Login() && GetBookingNotes() != ''" class="td-notice" role="note">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></svg>
        <span>{{GetBookingNotes()}}</span>
    </div>
</template>

<script lang="ts" src="./tour_heading.ts"></script>